module.exports = __webpack_public_path__ + "static/media/serpentine.2ca73585.png";